import React from "react";
import { TrainingTopic } from "../../types/TrainingTopic";
import { makeStyles } from "@material-ui/core";
import TrainingList from "./TrainingList";
import TimeHelper from "../../helpers/TimeHelper";
import CheckIcon from "@material-ui/icons/Check";

interface IProps {
  topic: TrainingTopic;
  index: number;
  showSmall: boolean;
  selectedTopicId: string;
  onClick: (topic: TrainingTopic) => void;
}

export default function TrainingListTopic(props: IProps) {
  const { topic, showSmall, selectedTopicId, onClick } = props;
  const classes = useStyles();

  function getClass() {
    let c = showSmall ? "bullet-sm" : "bullet";
    if (topic.status && topic.status.complete) c += " done";
    return c;
  }

  function getCircle() {
    return topic.status && topic.status.complete ? <CheckIcon /> : null;
  }

  return (
    <div className="topic">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          position: "relative"
        }}
        className={selectedTopicId === topic.trainingTopicId ? "selected" : ""}
        onClick={() => {
          onClick(topic);
        }}
      >
        <div className={getClass()}>{getCircle()}</div>
        <div style={{ padding: 15, flex: 1 }}>
          <div className={showSmall ? classes.titleSmall : classes.title}>
            {topic.topicTitle}
          </div>
          <div className={showSmall ? classes.subTitleSmall : classes.subTitle}>
            {TimeHelper.format(topic.timeToComplete)}
          </div>
        </div>
      </div>
      {topic.group && topic.subTopics ? (
        <TrainingList
          topics={topic.subTopics}
          isSubList={true}
          onTopicClick={onClick}
          selectedTopicId={selectedTopicId}
        />
      ) : null}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 16,
    fontWeight: 700
  },
  titleSmall: {
    fontSize: 14,
    marginLeft: 5,
    fontWeight: 400
  },
  subTitle: {
    fontSize: 10,
    marginTop: 5,
    opacity: 0.6
  },
  subTitleSmall: {
    fontSize: 10,
    marginTop: 5,
    marginLeft: 5,
    opacity: 0.6
  }
}));
